module.exports = __webpack_public_path__ + "img/c6.316d963e.jpg";